import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useCan } from '../context/auth_atoms';
import UnauthorizedPage from "../pages/403";

export const AccessInstagramInfluencers: React.FC = () => {
    const can = useCan();

    const accessible = can('read', 'instagram_influencers::data')

    if (!accessible) {
        return <UnauthorizedPage message={"Sorry, you are not authorized to access this content."}/>
    }

    return <Outlet/>
};

export default AccessInstagramInfluencers;